import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins';
import octaviaKit from '@/plugins/octavia.kit';
import VueApexCharts from 'vue-apexcharts';
import './fake-db/index.js';
import VueClipboard from 'vue-clipboard2'
import CompositionApi from '@vue/composition-api'
import JsonViewer from 'vue-json-viewer'

// Import JsonViewer as a Vue.js plugin
Vue.use(CompositionApi)
Vue.use(VueClipboard)
Vue.component('apexchart', VueApexCharts);
Vue.use(JsonViewer)
Vue.use(octaviaKit);
Vue.config.productionTip = false;

Vue.directive('can', {
  bind: function (el, binding, vnode) {
    const permissions = JSON.parse(localStorage.getItem('permissions') || "[]");
    const requiredPermission = binding.value; // 👈 aquí el valor real

    if (!permissions.includes(requiredPermission)) {
      vnode.elm.style.display = "none";
    }
  }
});

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
